export const SKIP_CREDIT_CALCULATION = Symbol('SKIP_CREDIT_CALCULATION');

export const shouldSkipCreditCalculation = (
  value: unknown,
): value is typeof SKIP_CREDIT_CALCULATION => value === SKIP_CREDIT_CALCULATION;
